const sections = {
  ActionForm: "ContentfulActionForm",
  ActionFormSubmission: "ContentfulActionFormSubmission",
  ActionNavigate: "ContentfulActionNavigate",
  ActionOpenVideo: "ContentfulActionOpenVideo",
  ActionRedirect: "ContentfulActionRedirect",
  CallToAction: "ContentfulCallToAction",
  ContentfulSectionRichText: "ContentfulSectionRichText",
  DynamicSection: "ContentfulSectionDynamic",
  FeaturedArticles: "ContentfulSectionFeaturedArticles",
  HighlightedBlog: "ContentfulSectionBlogFeature",
  Footer: "ContentfulFooter",
  Form: "ContentfulSectionForm",
  Header: "ContentfulHeader",
  Headline: "ContentfulHeadline",
  HeroVideo: "ContentfulSectionHeroVideo",
  ListOfAccordionCards: "ContentfulSectionListOfAccordionCards",
  OrderedList: "ContentfulOrderedList",
  ParagraphsList: "ContentfulParagraphsList",
  SectionCards: "ContentfulSectionCards",
  SectionHeroPhoto: "ContentfulSectionHeroPhoto",
  SectionList: "ContentfulSectionList",
  SectionListOfActions: "ContentfulSectionListOfActions",
  SectionQuote: "ContentfulSectionQuote",
  SideBySide: "ContentfulSectionSideBySide",
  Subheader: "ContentfulSubheader",
  TemplateDetailsSection: "ContentfulTemplateSection",
  TextSection: "ContentfulSectionText",
  VideoWrapper: "ContentfulVideoWrapper",
  WrapperSection: "ContentfulSectionWrapper",
  FeatureCards: "ContentfulFeatureCards",
  MapSection: "ContentfulSectionMap",
  CenterFeatures: "ContentfulCenterFeatures",
  InfoCardGrid: "ContentfulSectionInfoCardGrid",
  TeamTestimonial: "ContentfulSectionTeamTestimonial",
  SectionExploreRoles: "ContentfulSectionExploreRoles",
  SectionReferralActions: "ContentfulSectionReferralActions",
  SectionHomeHeroV2: "ContentfulSectionHomeHeroV2",
  SectionLogoBarV2: "ContentfulSectionLogoBarV2",
  SectionHomeSplitStickyV2: "ContentfulSectionHomeSplitStickyV2",
  SectionSearchAndFeaturedClinicsV2:
    "ContentfulSectionSearchAndFeaturedClinicsV2",
  SectionSplitSectionV2: "ContentfulSectionSplitSectionV2",
  SectionContactJumpstartCtaV2: "ContentfulSectionContactJumpstartCtaV2",
  SectionPageHeroV2: "ContentfulSectionPageHeroV2",
  SectionTestimonials: "ContentfulSectionTestimonials",
  SectionVersusV2: "ContentfulSectionVersusV2",
  SectionSplitStepsUpV2: "ContentfulSectionSplitStepsUpV2",
  SectionSplitAccordionV2: "ContentfulSectionSplitAccordionV2",
  SectionRoadmapV2: "ContentfulSectionRoadmapV2",
  SectionSplitImageCarouselV2: "ContentfulSectionSplitImageCarouselV2",
  SectionPathV2: "ContentfulSectionPathV2",
  SectionAccordionV2: "ContentfulSectionAccordionV2",
  SectionCardGridV2: "ContentfulSectionCardGridV2",
  SectionSplitContentListV2: "ContentfulSectionSplitContentListV2",
  SectionLinkGridV2: "ContentfulSectionLinkGridV2",
  SectionTheWholeChildModelV2: "ContentfulSectionTheWholeChildModelV2",
  SectionDarkmodeSplitContentV2: "ContentfulSectionDarkmodeSplitContentV2",
  SectionHorizontalCardSlideV2: "ContentfulSectionHorizontalCardSlideV2",
  SectionGridAccordionV2: "ContentfulSectionGridAccordionV2",
  SectionComparisonTableV2: "ContentfulSectionComparisonTableV2",
  SectionDarkmodePodcastHighlightV2:
    "ContentfulSectionDarkmodePodcastHighlightV2",
  SectionBookHighlightV2: "ContentfulSectionBookHighlightV2",
  SectionSocialFollowV2: "ContentfulSectionSocialFollowV2",
}

export default sections
